import { PingResultType } from "../../api/types"
import Table from "../../components/Table"
import { ColumnType } from "../../components/Table/types"
import { h } from "preact"
import { Card, CardHeader, CardBody } from "../../components/Card"
import PingTime from "../../components/PingTime"
import SeverityBadge from "../../components/SeverityBadge"
import LatencyPopoverCell from "../../components/LatencyPopoverCell"

type PingTableProps = {
   pings: PingResultType[]
   date: string
   name: string
   // when true, hide Flap/min and Akce columns (used for world-wide predefined list)
   hideFlapAndActions?: boolean
}

export default function PingAddresses({
   pings,
   date,
   name,
   hideFlapAndActions = false,
}: PingTableProps) {
   // Build column definition with optional omission of flap/actions
   const columns: ColumnType[] = [
      { key: "ip", label: "IP" },
      { key: "label", label: "Popis" },
      {
         key: "severity",
         label: "Severity",
         formatter: (cell: number) => <SeverityBadge severity={cell} />,
      },
      {
         key: "ping",
         label: "[ms]",
         thClassName: "text-end",
         tdClassName: "text-end",
         formatter: (_: any, row: any) => (
            <div className="d-flex w-100 justify-content-end">
               <LatencyPopoverCell row={row as PingResultType} variant="value" />
            </div>
         ),
      },
   ]

   if (!hideFlapAndActions) {
      columns.push({
         key: "flapPerMin",
         label: "Flap/min",
         title: "Počet změny stavu během minuty",
         tdClassName: "text-center",
         formatter: (cell: any) => (cell !== undefined && cell !== null ? String(cell) : "—"),
      })
   }

   columns.push({
      key: "payloadSize",
      label: "Payload",
      title: "ICMP payload",
      thClassName: "text-end",
      tdClassName: "text-end",
      formatter: (cell: any) => {
         if (cell === undefined || cell === null) return "—"
         return String(Number(cell)) + "B"
      },
   })

   if (!hideFlapAndActions) {
      columns.push({
         key: "actions",
         label: "Akce",
         title: "Historie a graf",
         tdClassName: "align-middle",
         formatter: (_: any, row: any) => (
            <div className="d-flex align-items-center" style={{ height: "100%" }}>
               <LatencyPopoverCell row={row as PingResultType} variant="actions" />
            </div>
         ),
      })
   }
   return (
      <Card>
         <CardHeader className="d-flex justify-content-between">
            <div>{name}</div>
            <div>
               <PingTime time={date} />
            </div>
         </CardHeader>
         <CardBody className="p-0">
            <Table columns={columns} data={pings} keyField="address" className="mb-0" />
         </CardBody>
      </Card>
   )
}
